module.exports = __webpack_public_path__ + "img/modular-bw-logo.8aac5a1.svg";